import React from "react";
import { useParams } from "react-router-dom";
import PartnerDashboardView from "../../../../features/partner-dashboard/PartnerDashboardView";
import PartnerPortalWelcomeHeader from "../../../../features/partner-dashboard/components/welcome-header/PartnerPortalWelcomeHeader";

const Home = () => {
  const { partnerID } = useParams();

  React.useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <PartnerDashboardView
      partnerId={Number(partnerID)}
      variant="partner"
      headerSlot={<PartnerPortalWelcomeHeader />}
    />
  );
};

export default Home;
